<template>
  <div class="base-page" :class="{'base-page-elderly': isElderly, 'fixed-page': isBottomBtnFixed}" ref="page">
    <div class="base-page-top" ref="top">
      <div class="top-header" v-if="showTopHeader">
        <slot name="top-content"></slot>
      </div>
      <div class="top-middle">
        <div class="base-page-tips" v-if="showTitle">
          <slot name="tips"></slot>
        </div>
        <div class="base-page-title" v-if="showTitle">
          <slot name="title"></slot>
        </div>
        <div class="base-page-desc" v-if="showDesc">
          <slot name="desc"></slot>
        </div>
        <div class="base-page-content">
          <slot></slot>
        </div>
        <div class="base-page-content" v-if="showIdCardAuth">
          <slot name="id-card-auth"></slot>
        </div>
        <div class="base-page-agree" v-show="nameIdentShowAgree">
          <slot name="agree"></slot>
        </div>
      </div>
    </div>
    <div class="base-page-bottom" :class="{'fixed-class': isBottomBtnFixed}" v-if="showBottom">
      <div class="base-page-agree" v-show="showAgree">
        <slot name="agree"></slot>
      </div>
      <div class="base-page-qa" ref="qa" v-show="showQa">
        <slot name="q-a">
          <div @click="toQa">常见问题</div>
        </slot>
      </div>
      <div class="base-page-footer" ref="footer" v-if="iFooterConfig.show">
        <slot name="footer">
          <component
            v-bind:is="'cube-button'"
            v-bind="iFooterConfig.props"
            v-on="iFooterConfig.listener"
            style="backgroud: #CCC;"
          >{{ iFooterConfig.props.value }}</component>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>

import { deepAssign } from 'common-js/util/tool'

const footerDefaultConfig = {
  show: true,
  props: {
    value: '',
    style: {
    },
  },
  listener: {},
}

export default {
  props: {
    showQa: {
      type: Boolean,
      default: true
    },
    showDesc: {
      type: Boolean,
      default: true
    },
    showTopHeader: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    showBottom: {
      type: Boolean,
      default: true
    },
    showAgree: {
      type: Boolean,
      default: true
    },
    nameIdentShowAgree: {
      type: Boolean,
      default: false
    },
    isBottomBtnFixed: {
      type: Boolean,
      default: false
    },
    showTips: {
      type: Boolean,
      default: false,
    },
    showIdCardAuth: {
      type: Boolean,
      default: false,
    },
    isElderly: {
      type: Boolean,
      default: false,
    },
    footerConfig: {
      type: Object,
      require: false,
      default: () => {
        return {
          show: true,
          props: {
            value: '',
          },
          listener: {},
        }
      }
    }
  },
  data() {
    return {

    }
  },
  computed: {
    iFooterConfig() {
      const res = deepAssign(footerDefaultConfig, this.footerConfig)
      return res
    }
  },
  methods: {
    toQa() {
      this.$emit('toQa')
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss" scope>
  @import "common-css/mixins.scss";
  .base-page {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: px2rem(10) 0;
    box-sizing: border-box;
    // overflow: auto;
    .base-page-agree {
      .cube-checkbox-wrap {
        align-items: flex-start !important;
        .base-page-desc {
          margin: 0!important;
        }
      }
    }
    .base-page-top {
      flex: 1;
      // overflow: auto;
      // background:
      //   linear-gradient(white 15px, hsla(0,0%,100%,0)) 0 0 / 100% 50px,
      //   radial-gradient(at top, rgba(0,0,0,.2), transparent 70%) 0 0 / 100% 15px,
      //   linear-gradient(to top, white 15px, hsla(0,0%,100%,0)) bottom / 100% 50px,
      //   radial-gradient(at bottom, rgba(0,0,0,.2), transparent 70%) bottom / 100% 15px;
      // background-repeat: no-repeat;
      // background-size: 100% 50px, 100% 15px;
      // background-attachment: local, scroll, local, scroll;
    }
    .base-page-title {
      font-family: PingFangSC-Medium;
      font-size: px2rem(32);
      font-weight: 900;
      color: #333333;
      line-height: px2rem(44);
      margin-bottom: px2rem(10);
      word-break: break-word;
    }
    .base-page-desc {
      color: #757575 !important;
      font-size: px2rem(24);
      line-height: 1.2;
      margin: px2rem(20) 0 px2rem(40);
      text-align: left;
    }
    .base-page-desc a {
      @include text-underline-color;
    }
    .base-page-bottom {
      width: 100%;
    }
    .base-page-qa {
      font-family: PingFangSC-Regular;
      font-size: px2rem(24);
      color: #666666;
      text-align: center;
      margin-bottom: px2rem(5);
      & > div {
        position: relative;
        display: inline-block;
        padding-left: px2rem(32);
        // &:before {
        //   content: '';
        //   position: absolute;
        //   display: block;
        //   left: px2rem(-4);
        //   top: 0;
        //   width: px2rem(30);
        //   height: px2rem(30);
        //   @include bg-image('../../common/images/question');
        //   background-size: contain;
        // }
      }
    }
    .base-page-footer {
      width: 100%;
    }
  }

  .base-page-elderly {
    .base-page-title {
      font-size: px2rem(46);
      line-height: px2rem(58);
    }

    .base-page-footer .cube-btn {
      font-size: px2rem(40);
    }
  }
  .fixed-page {
    padding: 0;
    .base-page-top {
      height: calc(100vh - 110px);
      overflow-y: auto;
      flex: none; // 取消 flex 自动增长
      .top-middle {
        padding: px2rem(40) px2rem(36) px2rem(10);
      }
    }
    .base-page-desc {
      margin: 0;
    }
    .base-page-title {
      color: #444444;
    }
    .base-page-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 1;
      padding: px2rem(5) px2rem(60) px2rem(40) px2rem(60);
      box-sizing: border-box;
    }
    .base-page-footer, .base-page-footer .cube-btn {
      border-radius: px2rem(16) !important;
      .cube-btn_disabled::after {
        border: none !important;
      }
    }
  }

  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .base-page-footer {
      margin-bottom: px2rem(10);
    }
  }
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .base-page-footer {
      margin-bottom: px2rem(10);
    }
  }
</style>
